import { render } from "./TransitionCollapse.vue?vue&type=template&id=7f9f849e&scoped=true"
import script from "./TransitionCollapse.vue?vue&type=script&lang=js"
export * from "./TransitionCollapse.vue?vue&type=script&lang=js"

import "./TransitionCollapse.vue?vue&type=style&index=0&id=7f9f849e&lang=scss&scoped=true"

import exportComponent from "/var/www/briskly/brskl/products/business/app.prod.new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9f849e"]])

export default __exports__